import React from 'react'
import Confetti from 'react-confetti'


// adds confetti. Might make it functional that a setting for this appears when its the last week of May!


export default () => {
  return (
    <Confetti
      colors={['#c7c7c7', '#084a91','#939393', '#052f5d']}
        // colors={['#de1642', '#ab1032', '#154091', '#0d295d', '#d5ad36', '#ca9703']}
    />
  )
}